// extracted by mini-css-extract-plugin
export default {"root":"_37XGH","small":"_2zUfA","normal":"WAxIJ"};